import { render } from "./ViberIcon.vue?vue&type=template&id=995022c6"
import script from "./ViberIcon.vue?vue&type=script&lang=js"
export * from "./ViberIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__